(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.searchModal = document.querySelector('search-modal');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.searchModal && this.searchModal.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const modal = document.querySelector('search-modal');
      if (modal) modal.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);


 


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-room-card-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ms-room-rail-section]').forEach((section) => {
      if (section.dataset.railReady === 'true') return;
      section.dataset.railReady = 'true';

      const rail = section.querySelector('[data-ms-room-rail]');
      const previous = section.querySelector('[data-ms-room-rail-prev]');
      const next = section.querySelector('[data-ms-room-rail-next]');
      if (!rail) return;

      const move = (direction) => {
        rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.82, 280), behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producttest-main-product"] && !Shopify.designMode) return;
  try {
    
  function initializeProductTestMain(root) {
    if (root.dataset.producttestReady === 'true') return
    root.dataset.producttestReady = 'true'

    const dialog = root.querySelector('[data-producttest-dialog]')
    const dialogSlides = Array.from(root.querySelectorAll('[data-dialog-image]'))
    const dialogStage = root.querySelector('[data-dialog-stage]')
    const dialogCounter = root.querySelector('[data-dialog-counter]')
    const dialogZoomIn = root.querySelector('[data-dialog-zoom-in]')
    const dialogZoomOut = root.querySelector('[data-dialog-zoom-out]')
    const dialogZoomReset = root.querySelector('[data-dialog-zoom-reset]')
    const gallery = root.querySelector('.producttest-gallery__grid')
    const dots = Array.from(root.querySelectorAll('[data-gallery-dot]'))
    const variantSelect = root.querySelector('[data-producttest-variant-select]')
    const variantInput = root.querySelector('[data-producttest-variant-input]')
    const quantityInput = root.querySelector('[data-producttest-quantity-input]')
    const etaProperty = root.querySelector('[data-producttest-eta-property]')
    const quantityDisplay = root.querySelector('[data-quantity-display]')
    const addButtons = Array.from(root.querySelectorAll('[data-producttest-add], [data-producttest-mobile-add]'))
    const priceBlock = root.querySelector('[data-producttest-price-block]')
    const price = root.querySelector('[data-producttest-price]')
    const compare = root.querySelector('[data-producttest-compare]')
    const sale = root.querySelector('[data-producttest-sale]')
    const mobilePrice = root.querySelector('[data-producttest-mobile-price]')
    const mobileCompare = root.querySelector('[data-producttest-mobile-compare]')
    const discountBanner = root.querySelector('[data-producttest-discount]')
    const discountTitle = discountBanner?.querySelector('[data-producttest-discount-title]')
    const discountCheckout = discountBanner?.querySelector('[data-producttest-discount-checkout]')
    const discountCode = discountBanner?.querySelector('[data-producttest-discount-code]')
    const discountMinimum = discountBanner?.querySelector('[data-producttest-discount-minimum]')
    const bricoOffer = root.querySelector('[data-producttest-brico-offer]')
    const detailsSection = document.querySelector('.test-product-content')
    const fulfilment = root.querySelector('.producttest-fulfilment')
    const deliveryStatus = fulfilment?.querySelector('[data-live-delivery-status]')
    const deliveryEta = fulfilment?.querySelector('[data-live-delivery-eta]')
    const supplierStatus = fulfilment?.querySelector('[data-live-supplier-status]')
    const restockStatus = fulfilment?.querySelector('[data-live-restock]')
    const mqabbaStatus = fulfilment?.querySelector('[data-mqabba-status]')
    const santaveneraRow = fulfilment?.querySelector('[data-santavenera-row]')
    const santaveneraStatus = fulfilment?.querySelector('[data-santavenera-status]')
    const normalizeMoneyText = (value) => {
      const parsed = new DOMParser().parseFromString(value || '', 'text/html')
      return parsed.body.textContent?.trim() || ''
    }
    let availabilityRequest = 0
    let dialogIndex = 0
    let dialogZoom = 1
    let eligibleDiscounts = []
    let currentPriceState = {
      priceCents: Number(priceBlock?.dataset.priceCents || 0),
      priceFormatted: normalizeMoneyText(priceBlock?.dataset.priceFormatted),
      compareCents: Number(priceBlock?.dataset.compareCents || 0),
      compareFormatted: normalizeMoneyText(priceBlock?.dataset.compareFormatted)
    }

    if (detailsSection && !detailsSection.id) detailsSection.id = 'producttest-details'

    const setStatus = (element, text, available) => {
      if (!element) return
      element.textContent = text
      element.classList.toggle('is-available', available)
    }

    const setEta = (text, checkoutValue = '') => {
      if (etaProperty) {
        const shouldPersist = root.dataset.producttestVendor === 'ikea'
          && Number(root.dataset.producttestLocalStock || 0) <= 0
          && Boolean(checkoutValue)
        etaProperty.disabled = !shouldPersist
        etaProperty.value = shouldPersist ? checkoutValue : ''
      }
      if (deliveryEta) {
        deliveryEta.textContent = text || ''
        deliveryEta.hidden = !text
      }
    }

    const formatDiscountMoney = (cents) => {
      const currency = priceBlock?.dataset.currency || 'EUR'
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency
        }).format(cents / 100)
      } catch (error) {
        return `€${(cents / 100).toFixed(2)}`
      }
    }

    const discountAppliesToProduct = (discount) => {
      const targetCollections = Array.isArray(discount.targetCollections) ? discount.targetCollections : []
      const targetProducts = Array.isArray(discount.targetProducts) ? discount.targetProducts : []
      if (!targetCollections.length && !targetProducts.length) return true

      const productHandle = priceBlock?.dataset.productHandle || ''
      const productCollections = (priceBlock?.dataset.collections || '').split(',').filter(Boolean)
      if (targetProducts.includes(productHandle)) return true
      return targetCollections.some((handle) => productCollections.includes(handle))
    }

    const customerMatchesDiscount = (discount) => {
      const segments = Array.isArray(discount.customerRestriction) ? discount.customerRestriction : []
      if (!segments.length) return true

      const customerTags = (priceBlock?.dataset.customerTags || '').split('|').filter(Boolean).map((tag) => tag.toLowerCase())
      const customerCountry = (priceBlock?.dataset.customerCountry || '').toUpperCase()
      const segmentMap = {
        'newsletter receivers': { type: 'tag', value: 'newsletter' },
        'bronze vip': { type: 'tag', value: 'bronze_vip' },
        'silver vip': { type: 'tag', value: 'silver_vip' },
        'gold vip': { type: 'tag', value: 'gold_vip' },
        'from malta': { type: 'country', value: 'MT' },
        'maltashopper family': { type: 'tag', value: 'maltashopper_family' },
        'staff': { type: 'tag', value: 'staff' }
      }

      return segments.some((segment) => {
        const rule = segmentMap[String(segment).toLowerCase()]
        if (!rule) return false
        if (rule.type === 'tag') return customerTags.includes(rule.value)
        return customerCountry === rule.value
      })
    }

    const discountedPrice = (discount, priceCents) => {
      if (discount.valueType === 'percentage') {
        return Math.round(priceCents * (1 - Number(discount.value || 0) / 100))
      }
      return priceCents - Math.round(Number(discount.value || 0) * 100)
    }

    const renderBasePrice = () => {
      const onSale = currentPriceState.compareCents > currentPriceState.priceCents
      if (bricoOffer) bricoOffer.hidden = !onSale
      if (price) {
        price.textContent = currentPriceState.priceFormatted
        price.classList.remove('is-discounted')
      }
      if (mobilePrice) mobilePrice.textContent = currentPriceState.priceFormatted
      if (compare) {
        compare.textContent = currentPriceState.compareFormatted
        compare.hidden = !onSale
      }
      if (mobileCompare) {
        mobileCompare.textContent = currentPriceState.compareFormatted
        mobileCompare.hidden = !onSale
      }
      if (sale) {
        sale.textContent = onSale
          ? `- ${Math.round(((currentPriceState.compareCents - currentPriceState.priceCents) / currentPriceState.compareCents) * 100)}%`
          : ''
        sale.hidden = !onSale
      }
    }

    const renderProductDiscount = () => {
      renderBasePrice()
      if (!discountBanner) return

      discountBanner.hidden = true
      if (!eligibleDiscounts.length || currentPriceState.priceCents <= 0) return

      const candidates = eligibleDiscounts
        .filter(discountAppliesToProduct)
        .map((discount) => {
          const meetsMinimum = !discount.minimumAmount || currentPriceState.priceCents / 100 >= Number(discount.minimumAmount)
          const discountedCents = discountedPrice(discount, currentPriceState.priceCents)
          const savings = meetsMinimum ? currentPriceState.priceCents - discountedCents : 0
          return { discount, meetsMinimum, discountedCents, savings }
        })
        .filter((candidate) => candidate.discountedCents > 0 && candidate.discountedCents < currentPriceState.priceCents)
        .sort((a, b) => Number(b.meetsMinimum) - Number(a.meetsMinimum) || b.savings - a.savings)

      if (!candidates.length) return
      const best = candidates[0]
      const discount = best.discount
      const valueLabel = discount.valueType === 'percentage'
        ? `${discount.value}% off`
        : `${formatDiscountMoney(Math.round(Number(discount.value || 0) * 100))} off`

      if (discountTitle) discountTitle.textContent = valueLabel
      if (discountCheckout) {
        discountCheckout.textContent = discount.code
          ? priceBlock.dataset.codeLabel || 'Use code'
          : priceBlock.dataset.automaticLabel || 'Applied automatically at checkout'
      }
      if (discountCode) {
        discountCode.hidden = !discount.code
        discountCode.textContent = discount.code || ''
        discountCode.dataset.code = discount.code || ''
      }
      if (discountMinimum) {
        discountMinimum.hidden = !discount.minimumAmount
        discountMinimum.textContent = discount.minimumAmount
          ? `${priceBlock.dataset.minimumLabel || 'Minimum spend'} ${formatDiscountMoney(Math.round(Number(discount.minimumAmount) * 100))}`
          : ''
      }

      if (best.meetsMinimum) {
        const discountedFormatted = formatDiscountMoney(best.discountedCents)
        if (price) {
          price.textContent = discountedFormatted
          price.classList.add('is-discounted')
        }
        if (mobilePrice) mobilePrice.textContent = discountedFormatted
        if (compare) {
          compare.textContent = currentPriceState.priceFormatted
          compare.hidden = false
        }
        if (mobileCompare) {
          mobileCompare.textContent = currentPriceState.priceFormatted
          mobileCompare.hidden = false
        }
        if (sale) {
          sale.textContent = discount.valueType === 'percentage'
            ? `- ${discount.value}%`
            : `- ${formatDiscountMoney(Math.round(Number(discount.value || 0) * 100))}`
          sale.hidden = false
        }
      }

      discountBanner.hidden = false
    }

    const fetchProductDiscounts = async () => {
      const endpoint = priceBlock?.dataset.discountUrl
      const productHandle = priceBlock?.dataset.productHandle
      if (!endpoint || !productHandle) return

      const params = new URLSearchParams({ product: productHandle })
      if (priceBlock.dataset.collections) params.set('collections', priceBlock.dataset.collections)

      try {
        const response = await fetch(`${endpoint}/discounts?${params.toString()}`)
        if (!response.ok) throw new Error('discount request failed')
        const discounts = await response.json()
        eligibleDiscounts = Array.isArray(discounts) ? discounts.filter(customerMatchesDiscount) : []
        renderProductDiscount()
      } catch (error) {
        eligibleDiscounts = []
        renderProductDiscount()
      }
    }

    discountCode?.addEventListener('click', async () => {
      const code = discountCode.dataset.code
      if (!code || !navigator.clipboard) return
      try {
        await navigator.clipboard.writeText(code)
        discountCode.textContent = priceBlock?.dataset.copiedLabel || 'Copied'
        setTimeout(() => {
          discountCode.textContent = code
        }, 1500)
      } catch (error) {
        discountCode.textContent = code
      }
    })

    const updateCollectionStock = (mqabbaQuantity, santaveneraQuantity) => {
      const text = fulfilment?.dataset
      if (!text) return
      if (root.dataset.producttestVendor === 'the white stone') return

      const unitsText = (quantity) => (text.liveUnits || '[qty] available').replace('[qty]', String(quantity))
      const mqabbaStock = Number(mqabbaQuantity || 0)
      const santaveneraStock = Number(santaveneraQuantity || 0)

      if (root.dataset.producttestVendor === 'casa') {
        const localStock = Number(root.dataset.producttestLocalStock || 0)
        const casaStock = santaveneraStock > 0 ? santaveneraStock : localStock
        setStatus(deliveryStatus, casaStock > 0 ? text.casaDelivery : text.liveConfirm, casaStock > 0)
        setEta(casaStock > 0 ? unitsText(casaStock) : '')
        setStatus(supplierStatus, casaStock > 0 ? unitsText(casaStock) : text.liveConfirm, casaStock > 0)
        setStatus(mqabbaStatus, text.casaCollection, false)
        if (santaveneraRow) santaveneraRow.hidden = santaveneraStock <= 0
        setStatus(santaveneraStatus, unitsText(santaveneraStock), santaveneraStock > 0)
        return
      }

      setStatus(mqabbaStatus, mqabbaStock > 0 ? unitsText(mqabbaStock) : text.collectionAfterArrival, mqabbaStock > 0)
      if (santaveneraRow) santaveneraRow.hidden = santaveneraStock <= 0
      setStatus(santaveneraStatus, unitsText(santaveneraStock), santaveneraStock > 0)
    }

    const formatFriendlyDate = (dateValue) => {
      if (!dateValue) return ''
      let day
      let month

      if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        const parts = dateValue.split('-')
        day = Number(parts[2])
        month = Number(parts[1])
      } else if (/^\d{2}-\d{2}-\d{2}$/.test(dateValue)) {
        const parts = dateValue.split('-')
        day = Number(parts[0])
        month = Number(parts[1])
      } else {
        return dateValue
      }

      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const suffix = day >= 11 && day <= 13 ? 'th' : ['th', 'st', 'nd', 'rd'][day % 10] || 'th'
      return `${day}${suffix} ${months[month - 1]}`
    }

    const formatRestock = (dateValue) => {
      if (!dateValue) return ''
      const range = dateValue.match(/between\s+(\d{2}-\d{2}-\d{2})\s+and\s+(\d{2}-\d{2}-\d{2})/)
      if (range) return `between ${formatFriendlyDate(range[1])} and ${formatFriendlyDate(range[2])}`
      return formatFriendlyDate(dateValue)
    }

    const fetchLiveAvailability = async (sku) => {
      if (!sku || !fulfilment) return
      if (root.dataset.producttestVendor !== 'ikea') return
      if (root.dataset.producttestLiveAvailability !== 'true') return

      const endpoint = root.dataset.producttestAvailabilityEndpoint
      if (!endpoint) return

      const localStock = Number(root.dataset.producttestLocalStock || 0)
      const text = fulfilment.dataset
      const unitsText = (quantity) => (text.liveUnits || '[qty] available').replace('[qty]', String(quantity))
      const requestId = ++availabilityRequest

      setStatus(supplierStatus, text.liveChecking || 'Checking IKEA availability...', false)
      if (restockStatus) restockStatus.hidden = true
      if (localStock > 0) {
        setStatus(deliveryStatus, text.liveAvailable, true)
        setEta(text.liveLocalEta)
      } else {
        setStatus(deliveryStatus, text.liveChecking, false)
        setEta('')
      }

      try {
        const separator = endpoint.includes('?') ? '&' : '?'
        const response = await fetch(`${endpoint}${separator}sku=${encodeURIComponent(sku)}`)
        if (!response.ok) throw new Error('availability request failed')
        const data = await response.json()
        if (requestId !== availabilityRequest) return
        // Not obtainable at all (IKEA's checkout refuses it, or a bundle part is
        // sold out) and nothing in Malta: switch the button to Sold Out now,
        // instead of letting the click fail at the cart (MALM bed 99047744, 29
        // Sep 2026). The worker sets the variant to DENY on this same visit, so
        // the next render shows Sold Out and the notify-me button by itself.
        if (data.oc_orderable === false && localStock <= 0) {
          addButtons.forEach((button) => {
            button.disabled = true
            const label = button.querySelector('[data-producttest-add-label]') || button
            label.textContent = button.dataset.soldLabel || 'Sold Out'
          })
        }
        if (data.coming_soon && localStock <= 0) {
          // Unreleased at IKEA: the launch date, not "sold out".
          const when = formatFriendlyDate(data.coming_soon_date)
          setStatus(supplierStatus, 'Coming soon at IKEA', false)
          setStatus(deliveryStatus, when ? `Available from ${when}` : 'Coming soon', false)
          setEta('')
          addButtons.forEach((button) => {
            button.disabled = true
            const label = button.querySelector('[data-producttest-add-label]') || button
            label.textContent = when ? `Coming soon: ${when}` : 'Coming soon'
          })
          return
        }
        const quantity = Number(data.quantity || 0)
        const onlineQuantity = Number(data.online_max_quantity || 0)
        const cataniaStock = data.status === 'HIGH_IN_STOCK' || data.status === 'LOW_IN_STOCK'
        const lowStock = data.status === 'LOW_IN_STOCK'

        if (cataniaStock) {
          const quantityLabel = quantity > 0 ? unitsText(quantity) : text.liveAvailable
          setStatus(supplierStatus, lowStock ? `${text.liveLowStock}: ${quantityLabel}` : `${text.liveCatania}: ${quantityLabel}`, true)

          if (localStock <= 0) {
            setStatus(deliveryStatus, text.liveAvailable, true)
            const friendlyEta = formatFriendlyDate(data.eta_date)
            setEta(
              friendlyEta ? `${text.liveEtaPrefix} ${friendlyEta} ${text.liveEtaSuffix}` : text.liveCataniaEta,
              friendlyEta
            )
          }
        } else if (data.piacenza_available) {
          setStatus(supplierStatus, text.liveNetwork, true)
          if (localStock <= 0) {
            setStatus(deliveryStatus, text.liveAvailable, true)
            // IKEA Catania restocks soon (ikea-proxy eta_source 'catania_restock'):
            // quote the first truck after the restock, not the 5-week line.
            const restockEta = data.eta_source === 'catania_restock' ? formatFriendlyDate(data.eta_date) : ''
            if (restockEta) {
              setEta(`${text.liveEtaPrefix} ${restockEta} ${text.liveEtaSuffix}`, restockEta)
            } else {
              setEta(text.livePiacenzaEta, 'Within 5 weeks')
            }
          }
        } else if (data.order_in_store_only) {
          setStatus(supplierStatus, text.liveOutOfStock, false)
          if (localStock <= 0) {
            setStatus(deliveryStatus, text.liveAvailable, true)
            setEta(text.liveOrderStore)
          }
        } else if (data.home_delivery) {
          setStatus(supplierStatus, onlineQuantity > 0 ? unitsText(onlineQuantity) : text.liveNetwork, true)
          if (localStock <= 0) {
            setStatus(deliveryStatus, text.liveAvailable, true)
            setEta(text.liveConfirm)
          }
        } else {
          setStatus(supplierStatus, text.liveOutOfStock, false)
          if (localStock <= 0) {
            setStatus(deliveryStatus, text.liveConfirm, false)
            setEta(root.dataset.producttestLastChance === 'true' ? '' : text.liveConfirm)
          }
        }

        if (data.restock_date && restockStatus) {
          const restockQuantity = Number(data.restock_quantity || 0)
          const quantitySuffix = restockQuantity > 0 ? ` (${unitsText(restockQuantity)})` : ''
          restockStatus.textContent = `${text.liveRestockPrefix} ${formatRestock(data.restock_date)}${quantitySuffix}`
          restockStatus.hidden = false
        }
      } catch (error) {
        if (requestId !== availabilityRequest) return
        setStatus(supplierStatus, fulfilment.dataset.liveError || 'Could not check live availability', false)
        if (localStock <= 0) {
          setStatus(deliveryStatus, fulfilment.dataset.liveConfirm || 'Availability to be confirmed', false)
          setEta('')
        }
      }
    }

    const fetchBundleAvailability = async (item) => {
      const bundle = item.closest('[data-producttest-bundle]')
      const status = item.querySelector('[data-bundle-status]')
      const statusText = item.querySelector('[data-bundle-status-text]')
      const restock = item.querySelector('[data-bundle-restock]')
      const sku = item.dataset.bundleSku
      const endpoint = root.dataset.producttestAvailabilityEndpoint
      const text = bundle?.dataset

      const updateStatus = (state, label) => {
        if (!status || !statusText) return
        status.classList.remove('is-checking', 'is-available', 'is-low', 'is-unavailable')
        status.classList.add(state)
        statusText.textContent = label
      }

      if (!text) return
      if (!sku || sku === 'N/A') {
        updateStatus('is-unavailable', text.bundleNoSku)
        return
      }
      if (!endpoint || root.dataset.producttestLiveAvailability !== 'true') {
        updateStatus('is-unavailable', text.bundleUnavailable)
        return
      }

      try {
        const separator = endpoint.includes('?') ? '&' : '?'
        const response = await fetch(`${endpoint}${separator}sku=${encodeURIComponent(sku)}`)
        if (!response.ok) throw new Error('bundle availability request failed')
        const data = await response.json()
        const quantity = Number(data.quantity || 0)

        if (data.status === 'HIGH_IN_STOCK') {
          const label = quantity > 0 ? text.bundleAvailable.replace('[qty]', String(quantity)) : text.bundleNetwork
          updateStatus('is-available', label)
        } else if (data.status === 'LOW_IN_STOCK') {
          const label = text.bundleLow.replace('[qty]', String(quantity))
          updateStatus('is-low', label)
        } else if (data.piacenza_available) {
          updateStatus('is-available', text.bundlePiacenza)
        } else if (data.home_delivery || data.order_in_store_only) {
          updateStatus('is-available', text.bundleNetwork)
        } else {
          updateStatus('is-unavailable', text.bundleUnavailable)
        }

        if (restock) {
          if (data.restock_date) {
            const restockQuantity = Number(data.restock_quantity || 0)
            const quantityLabel = restockQuantity > 0 ? ` (${restockQuantity} units)` : ''
            restock.textContent = `${text.bundleRestock} ${formatRestock(data.restock_date)}${quantityLabel}`
            restock.hidden = false
          } else {
            restock.hidden = true
          }
        }
      } catch (error) {
        updateStatus('is-unavailable', text.bundleError)
      }
    }

    const activeDialogImage = () => dialogSlides[dialogIndex]?.querySelector('.producttest-dialog__image')

    const applyDialogZoom = () => {
      const image = activeDialogImage()
      if (!image) return
      const isZoomed = dialogZoom > 1

      image.style.width = isZoomed ? `${dialogZoom * 100}%` : '100%'
      image.style.maxWidth = isZoomed ? 'none' : '100%'
      image.style.maxHeight = isZoomed ? 'none' : 'calc(100vh - 150px)'
      image.style.cursor = dialogZoom >= 3 ? 'zoom-out' : 'zoom-in'
      if (dialogZoomIn) dialogZoomIn.disabled = dialogZoom >= 3
      if (dialogZoomOut) dialogZoomOut.disabled = dialogZoom <= 1
      if (dialogZoomReset) dialogZoomReset.disabled = dialogZoom <= 1

      requestAnimationFrame(() => {
        if (!dialogStage) return
        if (isZoomed) {
          dialogStage.scrollLeft = Math.max(0, (dialogStage.scrollWidth - dialogStage.clientWidth) / 2)
          dialogStage.scrollTop = Math.max(0, (dialogStage.scrollHeight - dialogStage.clientHeight) / 2)
        } else {
          dialogStage.scrollLeft = 0
          dialogStage.scrollTop = 0
        }
      })
    }

    const setDialogZoom = (nextZoom) => {
      dialogZoom = Math.min(3, Math.max(1, nextZoom))
      applyDialogZoom()
    }

    const desktopMedia = window.matchMedia('(min-width: 990px)')

    const showDialogImage = (nextIndex) => {
      if (!dialogSlides.length) return
      dialogIndex = (nextIndex + dialogSlides.length) % dialogSlides.length
      dialogSlides.forEach((slide, index) => { slide.hidden = index !== dialogIndex })
      dialogSlides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()))
      if (desktopMedia.matches) {
        const activeVideo = dialogSlides[dialogIndex]?.querySelector('video')
        if (activeVideo) {
          activeVideo.muted = true
          activeVideo.play().catch(() => {})
        }
      }
      if (dialogCounter) dialogCounter.textContent = `${dialogIndex + 1} / ${dialogSlides.length}`
      setDialogZoom(1)
    }

    root.querySelectorAll('[data-gallery-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog) return
        showDialogImage(Number(button.dataset.galleryOpen || 0))
        dialog.showModal()
      })
    })

    root.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog?.close())
    root.querySelector('[data-dialog-previous]')?.addEventListener('click', () => showDialogImage(dialogIndex - 1))
    root.querySelector('[data-dialog-next]')?.addEventListener('click', () => showDialogImage(dialogIndex + 1))
    dialogZoomIn?.addEventListener('click', () => setDialogZoom(dialogZoom + 0.5))
    dialogZoomOut?.addEventListener('click', () => setDialogZoom(dialogZoom - 0.5))
    dialogZoomReset?.addEventListener('click', () => setDialogZoom(1))
    dialogStage?.addEventListener('click', (event) => {
      if (!event.target.classList.contains('producttest-dialog__image')) return
      setDialogZoom(dialogZoom >= 3 ? 1 : dialogZoom + 0.5)
    })
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close()
    })
    dialog?.addEventListener('keydown', (event) => {
      const handledKeys = ['ArrowLeft', 'ArrowRight', '+', '=', '-', '0']
      if (!handledKeys.includes(event.key)) return
      event.preventDefault()
      if (event.key === 'ArrowLeft') showDialogImage(dialogIndex - 1)
      if (event.key === 'ArrowRight') showDialogImage(dialogIndex + 1)
      if (event.key === '+' || event.key === '=') setDialogZoom(dialogZoom + 0.5)
      if (event.key === '-') setDialogZoom(dialogZoom - 0.5)
      if (event.key === '0') setDialogZoom(1)
    })
    dialog?.addEventListener('close', () => {
      setDialogZoom(1)
      dialogSlides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()))
    })

    if (desktopMedia.matches) {
      root.querySelectorAll('.producttest-gallery__inline-video').forEach((video) => {
        video.muted = true
        video.loop = true
        const playing = video.play()
        if (playing) {
          playing
            .then(() => video.closest('.producttest-gallery__item--video')?.classList.add('is-playing'))
            .catch(() => {})
        }
      })
    }

    gallery?.addEventListener('scroll', () => {
      if (!dots.length || gallery.clientWidth === 0) return
      const activeIndex = Math.round(gallery.scrollLeft / gallery.clientWidth)
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex))
    }, { passive: true })

    const updateQuantity = (nextQuantity) => {
      const quantity = Math.max(1, nextQuantity)
      if (quantityInput) quantityInput.value = String(quantity)
      if (quantityDisplay) quantityDisplay.textContent = String(quantity)
    }

    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) - 1))
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => updateQuantity(Number(quantityInput?.value || 1) + 1))

    fetchLiveAvailability(root.dataset.producttestSku)
    fetchProductDiscounts()
    root.querySelectorAll('[data-bundle-sku]').forEach(fetchBundleAvailability)

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0]
      if (!option) return
      if (variantInput) variantInput.value = option.value

      const priceCents = Number(option.dataset.priceCents || 0)
      const compareCents = Number(option.dataset.compareCents || 0)
      const available = option.dataset.available === 'true'
      root.dataset.producttestLocalStock = option.dataset.localStock || '0'
      updateCollectionStock(option.dataset.mqabbaStock, option.dataset.santaveneraStock)
      currentPriceState = {
        priceCents,
        priceFormatted: normalizeMoneyText(option.dataset.price),
        compareCents,
        compareFormatted: normalizeMoneyText(option.dataset.compare)
      }
      renderProductDiscount()
      addButtons.forEach((button) => {
        button.disabled = !available
        const label = button.querySelector('[data-producttest-add-label]') || button
        label.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel
      })
      fetchLiveAvailability(option.dataset.sku)
    })
  }

  document.querySelectorAll('[data-producttest-main]').forEach(initializeProductTestMain)

  // Floating launchers (CommSlayer chat bubble, Klaviyo price-drop chip) sit
  // fixed in the bottom corners and cover the ends of the full-width Add to
  // cart button on phones — a customer could not tap it (conv 120499). While
  // any buy button is on screen on mobile, fade the launchers out and make
  // them click-through; an OPEN chat window (.woot-widget-holder) is never
  // touched, and everything returns the moment the buttons scroll away.
  ;(function () {
    var buyButtons = document.querySelectorAll('.producttest-buy__button')
    if (!buyButtons.length) return
    var style = document.createElement('style')
    style.textContent = '@media (max-width: 989px) {'
      + ' body.pt-buy-visible .woot--bubble-holder,'
      + ' body.pt-buy-visible .kl-hub-launcher-container {'
      + ' opacity: 0 !important; pointer-events: none !important; transition: opacity .2s; } }'
    document.head.appendChild(style)
    // Scroll-based visibility check (rAF-throttled getBoundingClientRect).
    // Equivalent to IntersectionObserver for two elements, with one less
    // moving part. Note for testers: occluded/background tabs park scroll
    // events, rAF AND IO callbacks entirely — verify with a visible window.
    var ticking = false
    function update () {
      ticking = false
      var visible = false
      for (var i = 0; i < buyButtons.length; i++) {
        var r = buyButtons[i].getBoundingClientRect()
        if (r.bottom > 0 && r.top < window.innerHeight && r.width > 0) { visible = true; break }
      }
      document.body.classList.toggle('pt-buy-visible', visible)
    }
    function schedule () {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(update)
    }
    window.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule, { passive: true })
    update()
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-bulb-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-bulb-track]');
    var prevBtn = document.querySelector('[data-bulb-prev]');
    var nextBtn = document.querySelector('[data-bulb-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var sl = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = sl <= 10;
      nextBtn.hidden = sl >= max - 10;
    }
    prevBtn.addEventListener('click', function() { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { track.scrollBy({ left: 240, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-paired-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = "{{ section.id }}";
    var track = document.querySelector('[data-paired-track="' + sectionId + '"]');
    var prevBtn = document.querySelector('[data-paired-prev="' + sectionId + '"]');
    var nextBtn = document.querySelector('[data-paired-next="' + sectionId + '"]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var sl = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = sl <= 10;
      nextBtn.hidden = sl >= max - 10;
    }
    prevBtn.addEventListener('click', function() { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { track.scrollBy({ left: 240, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-product-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-cross-track]');
    var prevBtn = document.querySelector('[data-cross-prev]');
    var nextBtn = document.querySelector('[data-cross-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = scrollLeft <= 10;
      nextBtn.hidden = scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -240, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: 240, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    /* Update on resize */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-whitestone-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-ws-track]');
    var prevBtn = document.querySelector('[data-ws-prev]');
    var nextBtn = document.querySelector('[data-ws-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = scrollLeft <= 10;
      nextBtn.hidden = scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -260, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: 260, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
